import { Icon } from "./Icon.tsx";

/** "Unit Hydrographs" tab icon — axes plus an asymmetric flow-response
 * shape (steep rise, slower recession), the real shape a unit hydrograph
 * traces — distinct from CurveIcon.tsx's own smooth monotonic arc. */
export function HydrographIcon() {
  return (
    <Icon>
      <path d="M4 4v16h16" />
      <path d="M4 18c2 0 3-1 4-7s2-8 4-8 2 5 4 9 4 4 6 4" />
    </Icon>
  );
}
